<form [formGroup]="ticketForm">
  <div class="form-grid">
    <!-- Ticket Type -->
    <mat-form-field appearance="outline" class="span-2-cols">
      <mat-label>{{ "trips.activity.tickets-type" | translate }}</mat-label>
      <mat-select
        formControlName="ticketType"
      >
        <mat-option *ngFor="let type of ticketTypes" [value]="type">{{
          getTicketLabel(type) | translate
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Number of Tickets -->
    <input-number
      label="{{ 'trips.activity.tickets-number' | translate }}"
      formControlName="numberOfTickets"
      formFieldClass="span-2-cols"
      [required]="true"
      [onlyInteger]="true"
      [minValue]="1"
    >
    </input-number>
  </div>
</form>

<!-- Add Ticket Button -->
<div class="buttons-panel">
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="addTicket()"
    [disabled]="!ticketForm.valid"
  >
    {{ "trips.activity.tickets-add" | translate }}
  </button>
</div>

<!-- Ticket List Table -->
<table mat-table [dataSource]="tickets" class="mat-elevation-z8">
  <ng-container matColumnDef="ticketType">
    <th mat-header-cell *matHeaderCellDef>
      {{ "trips.activity.tickets-type" | translate }}
    </th>
    <td mat-cell *matCellDef="let ticket">{{ ticket.ticketType }}</td>
  </ng-container>
  <ng-container matColumnDef="numberOfTickets">
    <th mat-header-cell *matHeaderCellDef>
      {{ "trips.activity.tickets-number" | translate }}
    </th>
    <td mat-cell *matCellDef="let ticket">{{ ticket.numberOfTickets }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let ticket" class="action-column">
      <button mat-icon-button color="warn" (click)="deleteTicket(ticket)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
